import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import {
  DOCUMENT_FORMAT_LISTING_LOADED,
  DOCUMENT_FORMAT_SAVE
} from '../../actions/resume'

const initialFormatForm = {
  title: '',
  font: 1,
  contactAlignment: 1,
  contactStyle: 1,
  headingAlignment: 1,
  includeHeadings: true,
  textAlignment: 1,
  headerFontSize: 1,
  bodyFontSize: 1,
  resumeFormatId: 1
}
const reducers = combineReducers({
  documentFormatListingRequest: h2Api.restReducer(DOCUMENT_FORMAT_LISTING_LOADED),
  documentFormatFormRequest: h2Api.restReducer(DOCUMENT_FORMAT_SAVE),
  documentFormatForm: modelReducer(
    'jobtools.formats.documentFormatForm',
    initialFormatForm
  ),
  forms: formReducer('jobtools.formats', {
    documentFormatForm: initialFormatForm
  })
})

export default reducers
